import { useInvestorProfileMachine } from '../components/machine-provider';

export default useInvestorProfileMachine;
